import { encodedHotelParams } from "@/feature/hotel/search/lib/hotel-formatter-helper";
import type { IHotelsSearchSchema } from "@/feature/hotel/search/types/hotel-search-type";

import type { CustomUmrahCityKey } from "./state/custom-umrah-flow.slice";

export const CUSTOM_UMRAH_SOURCE = "umrah_custom";

export function isCustomUmrahSource(value?: string | null) {
  return value === CUSTOM_UMRAH_SOURCE;
}

export function parseCustomUmrahCityKey(
  value?: string | null,
): CustomUmrahCityKey | undefined {
  if (value === "makkah" || value === "madinah") {
    return value;
  }

  return undefined;
}

export function appendCustomUmrahSearchContext(
  params: URLSearchParams,
  {
    cityKey,
    source,
  }: {
    cityKey?: string | null;
    source?: string | null;
  },
) {
  const parsedCityKey = parseCustomUmrahCityKey(cityKey);

  if (!isCustomUmrahSource(source) || !parsedCityKey) {
    return params;
  }

  params.set("source", CUSTOM_UMRAH_SOURCE);
  params.set("umrah_city", parsedCityKey);

  return params;
}

export function buildCustomAwareHotelSearchHref(
  searchData: IHotelsSearchSchema,
  {
    cityKey,
    source,
  }: {
    cityKey?: string | null;
    source?: string | null;
  } = {},
) {
  const params = appendCustomUmrahSearchContext(
    new URLSearchParams(encodedHotelParams(searchData)),
    {
      cityKey,
      source,
    },
  );

  return `/hotels?${params.toString()}`;
}
